import React, {useState} from 'react';
import * as yup from 'yup';
import {FormProvider, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers';
import Toast from '../../../../components/toast/Toast';
import {t} from 'react-switch-lang';
import TextArea from '../../../../components/FormFields/Textarea';
import Modal from 'reactstrap/lib/Modal';
import {verifyForm} from '../../../../services/externalizations/externalizationService';

const VerifyExternalizationModal = ({open, formType, formId, isOpen}) => {
  const [loading, setLoading] = useState(false);
  const schema = yup.object().shape({
    reason: yup.string(),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const {handleSubmit, watch} = methods;
  const toggleShowModal = (e) => {
    e && e.preventDefault();
    isOpen(!open);
  };

  const watchReason = watch('reason');
  const submitForm = async (data) => {
    setLoading(true);
    const payload = {
      verified: true,
      reason: data?.reason,
    };
    try {
      const response = await verifyForm(formType, formId, payload);
      if (response.status === 200) {
        isOpen(!open);
        await Toast.fire({
          title: t('message.verifyFormAccepted'),
          icon: 'success',
          timer: 3000,
        });
      }

      await window.location.reload();
    } catch (err) {
      Toast.fire({
        title: t('message.errorApi'),
        icon: 'error',
      });
    } finally {
      setLoading(false);
    }
    isOpen(!open);
  };

  const handleCancel = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      verified: false,
      reason: watchReason,
    };
    try {
      const response = await verifyForm(formType, formId, payload);
      if (response.status === 200) {
        isOpen(!open);
        await Toast.fire({
          title: t('message.verifyFormDeclined'),
          icon: 'success',
          timer: 3000,
        });
      }
      await window.location.reload();
    } catch (err) {
      Toast.fire({
        title: t('message.errorApi'),
        icon: 'error',
      });
    }
    finally {
      setLoading(false);
    }
    isOpen(!open);
  };
  return (
    <div>
      <Modal isOpen={open} className="modal-sm verify-modal">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(submitForm)}>
            <div className="close-img">
              <img
                src="/images/exclusion.svg"
                alt="Exclusion"
                onClick={(e) => toggleShowModal(e)}
                style={{cursor: 'pointer'}}
              />
            </div>
            <div className="modal-header history-header">
              {t('externalization.verifyModalTitle')}
            </div>
            <div className="modal-body verify-modal">
              <p className={'pb-3 '}>{t('externalization.verifyExternalization')}</p>

              {/*<TextArea*/}
              {/*  name="reason"*/}
              {/*  className="form-control text-area"*/}
              {/*  placeholder={t('externalization.placeholder.reason')}*/}
              {/*/>*/}
            </div>
            <div className="modal-footer history-footer">
              <button disabled={loading} className="secondary-btn" onClick={handleCancel}>
                {t('buttons.refuse')}
              </button>
              <button disabled={loading} className="primary-btn">{t('buttons.accept')}</button>
            </div>
          </form>
        </FormProvider>
      </Modal>
    </div>
  );
};

export default VerifyExternalizationModal;